import { darken, desaturate, lighten } from 'polished';
import React from 'react'
import Chart from 'react-apexcharts';
import BarSkelitonLoader from '../../loader/BarSkelitonLoader';

const SingleReport = ({ isVisible, handleClickInnerGraph, handleClickInnerData, singleData, singleColor }) => {
    const labels = ['Payment 835', 'Payment 835 Lite', 'Patient Pay', 'Correspondence']
    const curent_labels = []
    console.log(singleData?.filter(i => i > 0))
    singleData?.forEach((i, index) => {
        if (i > 0) {
            curent_labels.push(labels[index])
        }
    })
    const finalData = singleData?.filter(i => i > 0)
    const options = {
        dataLabels: {
            enabled: true,
            style: {
                colors: ['black']
            },
            dropShadow: {
                enabled: false,
                enabledOnSeries: undefined,
                top: 0,
                left: 0,
                blur: 3,
                opacity: 0.35
            }
        },
        fill: {
            type: 'gradient',
        },

        chart: {
            id: 'basic-donut-inner',
            type: 'donut',
            toolbar: {
                show: false
            },
            fontFamily: 'Open Sans',
            events: {
                click: handleClickInnerGraph,
                dataPointSelection: handleClickInnerData
            }
        },
        labels: curent_labels,
        legend: {
            show: true,
            customLegendItems: curent_labels,
            offsetX: 0,
            offsetY: 100,
        },
        tooltip: {
            show: true,
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                const color = w.config.colors[seriesIndex];
                const mainLabel = w.globals.labels[seriesIndex]
                return `<div style="background-color:${color};padding:5px" class="">
                        <span style="color:${"#000"};"> ${`${mainLabel}: ${finalData[seriesIndex]}`}  </span>
                </div>`


            }
        },
        colors: [darken(0.1, singleColor), singleColor, lighten(0.1, singleColor), desaturate(0.2, singleColor)],

    };
    return (
        isVisible ?
            <BarSkelitonLoader report="time-report" /> :
            <Chart options={options} series={finalData} type="donut" height={'90%'} />
    )
}

export default SingleReport